import { styled } from "@mui/material/styles";
import { observer } from "mobx-react";
import React from "react";
const SvgImage = styled("div")(({ path, imagecolor }) => ({
    backgroundColor: imagecolor,
    WebkitMask: "url(" + path + ") no-repeat center / contain",
    filter: "none !important", // overwrite css style
}));
const SideNavItem = styled("div")(({ color, hoverColor }) => ({
    "&:hover": {
        backgroundColor: hoverColor,
        "& > div": {
            backgroundColor: color,
        },
    },
}));
export const SideNavElement = observer((props) => {
    const handleToggle = (event) => {
        props.onClick && props.onClick(event);
    };
    // necessary to do not break api
    const getPrimaryColor = () => {
        return props.appModel ? props.appModel.theme.primaryColor : "#009fe0";
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "side-nav-element" },
            React.createElement(SideNavItem, { className: "side-nav__item", title: props.title, onClick: handleToggle, hoverColor: getPrimaryColor(), color: "#FFFFFF" },
                React.createElement(SvgImage, { path: props.imageSrc, className: "side-nav__item--icon", imagecolor: getPrimaryColor() })),
            props.children)));
});
export default SideNavElement;
